module.exports = __webpack_public_path__ + "img/index_2025_10_23.ede594fa.png";